import React, { useState } from 'react';
import { Button } from '../ui/button';

import SelectField from '@/components/atoms/SelectField';
import EditSubscriptionIcon from '@/assets/icons/edit-subscription.svg';
import SuspendUserIcon from '@/assets/icons/suspend-user.svg';
import InputField from '@/components/atoms/InputField';

interface SuspendUserModalProps {
  isOpen: boolean;
  onBanClick: (banPeriod: number, timeUnit: string) => void;
  onClose?: () => void;
  banInfo?: any;
}

const SuspendUserModal: React.FC<SuspendUserModalProps> = ({ isOpen, onBanClick, onClose = () => {}, banInfo }) => {
  if (!isOpen) return null;

  const [banPeriod, setBanPeriod] = useState<number | undefined>(banInfo?.ban_period || undefined);
  const [timeUnit, setTimeUnit] = useState<string>(banInfo?.time_unit || 'day');

  return (
    <div className="fixed w-screen h-screen top-0 left-0 bg-[rgba(82,80,96,0.5)] backdrop-blur-[8px] z-50 flex items-center justify-center">
      <div className="bg-white rounded-[16px] w-[327px] overflow-hidden">
        <div className="w-full py-7 px-7 md:p-0 flex flex-col items-center justify-center gap-2">
          <div className="rounded-t-[16px] md:bg-lightPurple w-full md:mb-4 md:py-8">
            <img className="mb-3 md:h-[140px] md:w-[140px] mx-auto" src={SuspendUserIcon} alt={`icon`} />
          </div>
          <p className="md:px-4 font-bold text-xl text-center leading-[24.3px] md:mb-[0.15rem]">
            Suspend This User for
          </p>
          <div className="w-full md:px-5 flex items-end justify-end gap-4">
            <InputField
              name="suspendDays"
              value={banPeriod !== undefined ? banPeriod.toString() : ''}
              onChange={(value: any) => {
                const inputValue = value.target.value;
                if (inputValue === '' || inputValue === null) {
                  setBanPeriod(undefined);
                } else {
                  setBanPeriod(Number(inputValue));
                }
              }}
              type="number"
              placeholder="e.g 10"
              className="flex-1"
              size="sm"
              label="Ban Period"
              min={0}
            />
            <SelectField
              name="plan"
              options={[
                { label: 'Hour', value: 'hour' },
                { label: 'Day', value: 'day' },
                { label: 'Week', value: 'week' },
                { label: 'Month', value: 'month' },
                { label: 'Year', value: 'year' }
              ]}
              value={timeUnit}
              onChange={(value) => {
                setTimeUnit(value as string);
              }}
              buttonClassName="h-[40px] !py-[10px] !px-4"
              placeholder="Unit"
              className="flex-1 h-fit"
            />
          </div>
          <span className="text-xs text-center text-secondary font-medium md:px-5">
            User unable to log in until banned period ended
          </span>
        </div>
        <div className="flex md:gap-4 md:px-5 md:mb-6 md:mt-6">
          <Button
            onClick={onClose}
            className={`w-full !rounded-none font-semibold h-[52px] md:text-[1rem] md:font-semibold md:!rounded-full md:h-[44px]`}
            // variant={'primary-reverse'}
          >
            Cancel
          </Button>

          <Button
            onClick={() => onBanClick(banPeriod || 0, timeUnit)}
            className={`w-full text-base bg-[#E8507E] font-semibold h-[52px] !rounded-none  md:text-[1rem] md:font-semibold md:!rounded-full md:h-[44px]`}
            variant={'destructive'}
          >
            Ban
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuspendUserModal;
